import { Controller } from 'react-hook-form';
import { Checkbox, FormControlLabel } from '@mui/material';
import { getLabelForCheckbox } from '../../services/DataHelperFunctions';

import type { ICheckboxGroupChangeField, ICheckboxGroupFieldProps } from '../../../types';

const handleCheckboxChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  field: ICheckboxGroupChangeField,
  fieldData: { name: string; code: string }
) => {
  const isChecked = e.target.checked;

  const currentValue = Array.isArray(field.value) ? field.value : [];
  if (isChecked) {
    field.onChange([...currentValue, fieldData.code]);
  } else {
    field.onChange(currentValue.filter((selected: string) => selected !== fieldData.code)); // Remove the object
  }
};

export const CheckboxGroup: React.FC<ICheckboxGroupFieldProps> = ({
  formField,
  label,
  checkFieldDisabled,
  control,
  gridClass,
}) => {
  // Determine effective grid class
  const effectiveGridClass = gridClass ?? '';
  return (
    <fieldset className="inputFieldset w-100 mt-1em">
      <legend className="inputLegend" id="views">
        {label} {formField.rules?.required && <span className="asterisk">*</span>}
      </legend>

      <Controller //this block work for applicationform,market association,language association
        name={formField.field}
        control={control}
        rules={formField.rules}
        render={({ field }) => (
          <div className={effectiveGridClass}>
            {formField.values?.map((fieldConfig) => (
              <div key={fieldConfig.name} className="pt-0">
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value?.indexOf(fieldConfig.code) > -1}
                      disabled={checkFieldDisabled(
                        formField.field,
                        fieldConfig.name,
                        fieldConfig.code
                      )}
                      onChange={(e) => handleCheckboxChange(e, field, fieldConfig)}
                    />
                  }
                  label={getLabelForCheckbox(
                    formField.labelFormat,
                    fieldConfig.code,
                    fieldConfig.name
                  )}
                  labelPlacement="end"
                  name={formField.field}
                />
              </div>
            ))}
          </div>
        )}
      />
    </fieldset>
  );
};
